import React, { Component } from 'react';

import SearchBar from './SearchBar'
import Featured from './Featured';
import SearchResults from './SearchResults'

class content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
    }
  }

  onSearch = (searchValue, source) => {
    this.setState({searchValue});
  }
  
  render() {
    return (
      <div className={`content ${this.props.contentVisible ? 'content__open' : ''}`}>
        <div className="content--container" >
          <SearchBar 
          onChangeSource={this.props.onChangeSource}
          onSearch={this.onSearch}
          source={this.props.source} />

          <div className="content--scrollable">
            {
              this.state.searchValue.length === 0
              ? <Featured
              playing={this.props.playing}
              isPlaying={this.props.isPlaying}
              source={this.props.source}
              onPlayTrack={this.props.onPlayTrack} />
              : <SearchResults
              playing={this.props.playing}
              isPlaying={this.props.isPlaying}
              onPlayTrack={this.props.onPlayTrack}
              source={this.props.source}
              searchValue={this.state.searchValue} />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default content;


// WEBPACK FOOTER //
// ./src/components/Content.jsx